import {wdiCore} from '@/components/WdiControls';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Col, Row} from 'antd';
import {responseResultError, responseResultOk} from "@/utils/response";
import {useEffect, useState, useRef, useCallback} from "react";

export const ColumnType = {
  //坎级金额
  MinValue1: 1,
  //坎级听数
  MinValue2: 2,
  //坎级比例
  MinValue3: 3,
  //结案比例
  StandardValue1: 4,
  //单位费用（听）
  StandardValue2: 5,
};

type SCTRateGridHeaderProps = {};
const headerStyle: React.CSSProperties = {
  textAlign: 'left',
  height: '35px',
  lineHeight: '35px',
  paddingLeft: '2px',
  border: '1px solid #DDDDDD',
};
const SCTRateGridHeader: React.FC<SCTRateGridHeaderProps> = (props: SCTRateGridHeaderProps) => {
  return (
    <Row style={{border: '1px solid #DDDDDD', borderCollapse: 'collapse'}}>
      <Col span={5} style={headerStyle}>坎级金额</Col>
      <Col span={5} style={headerStyle}>坎级听数</Col>
      <Col span={5} style={headerStyle}>坎级比例(%)</Col>
      <Col span={4} style={headerStyle}>结案比例(%)</Col>
      <Col span={5} style={headerStyle}>单听费用</Col>
    </Row>
  );
};

type SCTRateGridRowValue = {
  isQuantity?: boolean;
  minValue1?: number; // 坎级金额
  minValue2?: number; // 坎级听数
  minValue3?: number; // 坎级比例
  standardValue?: number; // 结案比例/单位费用
};

type SCTRateGridRowProps = {
  rowIndex: number;
  readonly?: boolean;
  value?: SCTRateGridRowValue;
  onChange: (columnType: number, rowIndex: number, v: number | undefined) => void;
  isQuantity?: boolean;
  isInDirect?: boolean;
  disableMinValue1?: boolean;
  disableMinValue2?: boolean;
  disableMinValue3?: boolean;
  isFirstRow?: boolean;
};

const rowStyle: React.CSSProperties = {
  textAlign: 'left',
  height: '35px',
  lineHeight: '35px',
  paddingLeft: '1px',
  border: '1px solid #DDDDDD',
};

const isNullOrEmpty = (value: any) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (value === "") {
    return true;
  }
  return false;
};

const SCTRateGridRow: React.FC<SCTRateGridRowProps> = (props: SCTRateGridRowProps) => {
  const getStandardValue2Min = () => {
    return props.isInDirect ? undefined : 0;
  };

  // 判断当前行是否允许编辑坎级金额
  const isMinValue1Editable = () => {
    // 第一行始终不可编辑
    if (props.isFirstRow) return false;
    return !props.readonly &&
      props.isQuantity === false &&
      !props.disableMinValue1;
  };

  // 判断当前行是否允许编辑坎级听数
  const isMinValue2Editable = () => {
    // 第一行始终不可编辑
    if (props.isFirstRow) return false;
    return !props.readonly &&
      props.isQuantity === true &&
      !props.disableMinValue2;
  };

  // 判断当前行是否允许编辑坎级比例
  const isMinValue3Editable = () => {
    // 第一行始终不可编辑
    if (props.isFirstRow) return false;
    return !props.readonly &&
      props.isQuantity !== undefined &&
      props.isQuantity !== null &&
      !props.disableMinValue3;
  };

  // 判断当前行是否允许编辑结案比例
  const isStandardValue1Editable = () => {
    return !props.readonly && props.isQuantity === false;
  };

  // 判断当前行是否允许编辑单位费用
  const isStandardValue2Editable = () => {
    return !props.readonly && props.isQuantity === true;
  };

  return (
    <Row>
      {/* 坎级金额 */}
      <Col span={5} style={rowStyle}>
        <WdiInputNumber
          readOnly={!isMinValue1Editable()}
          min={0}
          value={props.value?.minValue1}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.MinValue1, props.rowIndex, wdiCore.Number.ToNumber(value, 2));
              } else {
                props.onChange(ColumnType.MinValue1, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>

      {/* 坎级听数 */}
      <Col span={5} style={rowStyle}>
        <WdiInputNumber
          readOnly={!isMinValue2Editable()}
          min={0}
          value={props.value?.minValue2}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.MinValue2, props.rowIndex, wdiCore.Number.ToNumber(value, 2));
              } else {
                props.onChange(ColumnType.MinValue2, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>

      {/* 坎级比例(%) */}
      <Col span={5} style={rowStyle}>
        <WdiInputNumber
          readOnly={!isMinValue3Editable()}
          format="p"
          digits={4}
          min={0}
          value={props.value?.minValue3}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.MinValue3, props.rowIndex, wdiCore.Number.ToNumber(value, 6));
              } else {
                props.onChange(ColumnType.MinValue3, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>

      {/* 结案比例(%) */}
      <Col span={4} style={rowStyle}>
        <WdiInputNumber
          readOnly={!isStandardValue1Editable()}
          format="p"
          digits={4}
          min={0}
          value={props.isQuantity === false ? props.value?.standardValue : undefined}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.StandardValue1, props.rowIndex, wdiCore.Number.ToNumber(value, 6));
              } else {
                props.onChange(ColumnType.StandardValue1, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>

      {/* 单位费用 */}
      <Col span={5} style={rowStyle}>
        <WdiInputNumber
          readOnly={!isStandardValue2Editable()}
          min={getStandardValue2Min()}
          value={props.isQuantity === true ? props.value?.standardValue : undefined}
          onChange={
            (value: any) => {
              if (!wdiCore.Object.IsNullOrUndefined(value) && !wdiCore.String.IsNullOrEmpty(value)) {
                props.onChange(ColumnType.StandardValue2, props.rowIndex, wdiCore.Number.ToNumber(value, 2));
              } else {
                props.onChange(ColumnType.StandardValue2, props.rowIndex, undefined);
              }
            }
          }
        />
      </Col>
    </Row>
  );
};

type SCTRateGridValue = {
  isQuantity?: boolean;
  items: SCTRateGridRowValue[];
};

type SCTRateGridProps = {
  readonly?: boolean;
  value?: SCTRateGridValue;
  onChange?: (value?: SCTRateGridValue) => void;
  isQuantity?: boolean;
  isInDirect?: boolean;
  isPos?: boolean;
};

const SCTRateGrid: React.FC<SCTRateGridProps> = (props: SCTRateGridProps) => {
  const [disableMinValue1, setDisableMinValue1] = useState<boolean>(false);
  const [disableMinValue2, setDisableMinValue2] = useState<boolean>(false);
  const [disableMinValue3, setDisableMinValue3] = useState<boolean>(false);

  const prevIsQuantityRef = useRef<boolean | undefined>(props.isQuantity);

  const checkRows2To5HasValue = useCallback((field: 'minValue1' | 'minValue2' | 'minValue3') => {
    if (!props.value?.items || props.value.items.length < 5) return false;

    for (let i = 1; i < 5; i++) {
      if (!isNullOrEmpty(props.value.items[i][field])) {
        return true;
      }
    }
    return false;
  }, [props.value?.items]);

  const updateColumnEditStatus = useCallback(() => {
    if (props.isPos) {
      setDisableMinValue1(false);
      setDisableMinValue2(false);
      setDisableMinValue3(true);
      return;
    }

    if (props.isQuantity === true) {
      const hasMinValue2 = checkRows2To5HasValue('minValue2');
      const hasMinValue3 = checkRows2To5HasValue('minValue3');
      setDisableMinValue2(hasMinValue3);
      setDisableMinValue3(hasMinValue2);
    } else if (props.isQuantity === false) {
      const hasMinValue1 = checkRows2To5HasValue('minValue1');
      const hasMinValue3 = checkRows2To5HasValue('minValue3');
      setDisableMinValue1(hasMinValue3);
      setDisableMinValue3(hasMinValue1);
    } else {
      setDisableMinValue1(true);
      setDisableMinValue2(true);
      setDisableMinValue3(true);
    }
  }, [props.isQuantity, props.isPos, checkRows2To5HasValue]);

  const updateFirstRowValues = useCallback(() => {
    if (!props.value?.items || props.value.items.length === 0) return;
    if (props.isPos) return;

    const firstRow = props.value.items[0];
    let needUpdate = false;
    const newItems = [...props.value.items];

    if (props.isQuantity === true) {
      const hasMinValue2 = checkRows2To5HasValue('minValue2');
      const hasMinValue3 = checkRows2To5HasValue('minValue3');

      if (hasMinValue2 && firstRow.minValue3 === 0) {
        // 编辑坎级听数2-5行，清空第一行坎级比例
        newItems[0] = {...newItems[0], minValue3: undefined};
        needUpdate = true;
      } else if (!hasMinValue2 && isNullOrEmpty(firstRow.minValue3)) {
        // 坎级听数2-5行都为空，恢复第一行坎级比例为0
        newItems[0] = {...newItems[0], minValue3: 0};
        needUpdate = true;
      }

      if (hasMinValue3 && firstRow.minValue2 === 0) {
        // 编辑坎级比例2-5行，清空第一行坎级听数
        newItems[0] = {...newItems[0], minValue2: undefined};
        needUpdate = true;
      } else if (!hasMinValue3 && isNullOrEmpty(firstRow.minValue2)) {
        // 坎级比例2-5行都为空，恢复第一行坎级听数为0
        newItems[0] = {...newItems[0], minValue2: 0};
        needUpdate = true;
      }
    } else if (props.isQuantity === false) {
      const hasMinValue1 = checkRows2To5HasValue('minValue1');
      const hasMinValue3 = checkRows2To5HasValue('minValue3');

      if (hasMinValue1 && firstRow.minValue3 === 0) {
        // 编辑坎级金额2-5行，清空第一行坎级比例
        newItems[0] = {...newItems[0], minValue3: undefined};
        needUpdate = true;
      } else if (!hasMinValue1 && isNullOrEmpty(firstRow.minValue3)) {
        // 坎级金额2-5行都为空，恢复第一行坎级比例为0
        newItems[0] = {...newItems[0], minValue3: 0};
        needUpdate = true;
      }

      if (hasMinValue3 && firstRow.minValue1 === 0) {
        // 编辑坎级比例2-5行，清空第一行坎级金额
        newItems[0] = {...newItems[0], minValue1: undefined};
        needUpdate = true;
      } else if (!hasMinValue3 && isNullOrEmpty(firstRow.minValue1)) {
        // 坎级比例2-5行都为空，恢复第一行坎级金额为0
        newItems[0] = {...newItems[0], minValue1: 0};
        needUpdate = true;
      }
    }

    if (needUpdate) {
      props.onChange?.({
        ...props.value,
        items: newItems
      });
    }
  }, [props.isQuantity, props.isPos, props.value, checkRows2To5HasValue, props.onChange]);

  const onValueChange = (columnType: number, rowIndex: number, v: number | undefined) => {
    const value: SCTRateGridValue = {
      isQuantity: props.isQuantity,
      items: []
    };

    props.value?.items?.forEach((item, itemIndex) => {
      let result = {...item};
      if (itemIndex === rowIndex) {
        if (columnType == ColumnType.MinValue1) {
          result.minValue1 = v;
        }
        if (columnType == ColumnType.MinValue2) {
          result.minValue2 = v;
        }
        if (columnType == ColumnType.MinValue3) {
          result.minValue3 = v;
        }
        if (columnType == ColumnType.StandardValue1 || columnType == ColumnType.StandardValue2) {
          result.standardValue = v;
        }
      }
      value.items.push(result);
    });
    value.isQuantity = props.isQuantity;
    props.onChange?.(value);
  };

  useEffect(() => {
    const prevIsQuantity = prevIsQuantityRef.current;
    const currentIsQuantity = props.isQuantity;

    prevIsQuantityRef.current = currentIsQuantity;

    if (prevIsQuantity !== currentIsQuantity && props.value?.items) {
      let needUpdate = false;
      const newItems = [...props.value.items];

      if (prevIsQuantity === true && currentIsQuantity === false) {
        newItems.forEach((_, index) => {
          newItems[index] = {
            ...newItems[index],
            minValue2: undefined,
            standardValue: undefined
          };
        });
        needUpdate = true;
      } else if (prevIsQuantity === false && currentIsQuantity === true) {
        newItems.forEach((_, index) => {
          newItems[index] = {
            ...newItems[index],
            minValue1: undefined,
            standardValue: undefined
          };
        });
        needUpdate = true;
      }

      if (props.isPos && newItems.length > 0) {
        newItems[0] = {
          ...newItems[0],
          standardValue: newItems[0].standardValue ? newItems[0].standardValue : 0,
        };
        needUpdate = true;
      }

      if (needUpdate) {
        props.onChange?.({
          ...props.value,
          items: newItems
        });
        return;
      }
    }
  }, [props.isQuantity]);

  useEffect(() => {
    updateColumnEditStatus();
  }, [updateColumnEditStatus]);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateFirstRowValues();
    }, 10);

    return () => clearTimeout(timer);
  }, [updateFirstRowValues]);

  return (
    <>
      <SCTRateGridHeader/>
      {
        props.value &&
        props.value.items &&
        props.value.items?.map((item, itemIndex) => (
          <SCTRateGridRow
            key={itemIndex}
            rowIndex={itemIndex}
            readonly={props.readonly}
            value={item}
            onChange={onValueChange}
            isQuantity={props.isQuantity}
            isInDirect={props.isInDirect}
            disableMinValue1={disableMinValue1}
            disableMinValue2={disableMinValue2}
            disableMinValue3={disableMinValue3}
            isFirstRow={itemIndex === 0}
          />
        ))
      }
    </>
  );
};

const res = {
  rowNumberP1: (rowNumber: number) => {
    return "第" + rowNumber + "行，"
  },
  criticalMust0: "坎级金额/数量必须为0",
  criticalOnly1: "坎级值不能为空",
  resultOnly1: "结案比例/单位费用必须填写1个",
  rebateRateMust0_1: "结案比例必须在0～1之间",
  unitFeeMustGt0: "单位费用必须为正数",
  criticalMustNumber: "坎级值必须为数字",
  currentMustGtLast: "坎级金额/坎级数量要大于上一行的",
};

const initSalesContractRateGrid = (
  revenueTypeId: number,
  isInDirect: boolean,
  settlementRateType: number,
  values?: any[],
) => {
  const rows: SCTRateGridRowValue[] = [];
  let isQuantity: boolean | undefined;
  let isPos = false;

  if (revenueTypeId === 3 || revenueTypeId === 5) {
    isQuantity = true;
  } else if (revenueTypeId === 4 || revenueTypeId === 6) {
    isQuantity = false;
  } else if (revenueTypeId === 7) {
    isQuantity = true;
    isPos = true;
  } else if (revenueTypeId === 8) {
    isQuantity = false;
    isPos = true;
  }

  if (values && values.length > 0) {
    values.forEach((item) => {
      const row: SCTRateGridRowValue = {
        isQuantity: isQuantity,
        standardValue: item.standardValue,
      };
      if (settlementRateType === 1) {
        row.minValue1 = item.value;
      } else if (settlementRateType === 2) {
        row.minValue2 = item.value;
      } else if (settlementRateType === 3) {
        row.minValue3 = item.value;
      }
      if (isPos) {
        row.minValue3 = undefined;
      }
      rows.push(row);
    });
  }

  // 返利标准必须是5行，如果数据不足5行，补充空行
  for (let i = rows.length; i < 5; i++) {
    if (i === 0 && rows.length === 0) {
      if (isQuantity === true) {
        rows.push({
          minValue2: 0,
          minValue3: isPos ? undefined : 0,
          standardValue: isPos ? 0 : undefined,
          isQuantity: isQuantity,
        });
      } else if (isQuantity === false) {
        rows.push({
          minValue1: 0,
          minValue3: isPos ? undefined : 0,
          standardValue: isPos ? 0 : undefined,
          isQuantity: isQuantity,
        });
      } else {
        rows.push({
          minValue1: undefined,
          minValue2: undefined,
          minValue3: undefined,
          standardValue: undefined,
          isQuantity: isQuantity,
        });
      }
    } else {
      rows.push({
        minValue1: undefined,
        minValue2: undefined,
        minValue3: undefined,
        standardValue: undefined,
        isQuantity: isQuantity,
      });
    }
  }

  return {
    items: rows,
    isQuantity: isQuantity,
  };
};

const initRows = (rateGridValue?: SCTRateGridValue) => {
  const rows: any[] = [];
  if (rateGridValue?.items) {
    rateGridValue?.items?.forEach((item: any, index) => {
      const obj = {
        minValue1: item.minValue1,
        minValue2: item.minValue2,
        minValue3: item.minValue3,
        standardValue: item.standardValue,
        isQuantity: rateGridValue.isQuantity
      };
      rows.push(obj);
    })
  }
  return rows;
}

const convertToResult = (rateGridValue?: SCTRateGridValue, isInDirect?: boolean, settlementRateType?: number, isPos?: boolean) => {
  const rows = initRows(rateGridValue);
  const values: any[] = [];

  if (rows && rows.length) {
    let currentRow = rows[0];
    let currentValue: any = {};

    const getValueField = () => {
      if (isPos) {
        const firstRow = rows[0];
        if (firstRow && firstRow.isQuantity === true) return 'minValue2';
        if (firstRow && firstRow.isQuantity === false) return 'minValue1';
      }
      if (settlementRateType === 1) return 'minValue1';
      if (settlementRateType === 2) return 'minValue2';
      if (settlementRateType === 3) return 'minValue3';
      return 'minValue1';
    };

    const valueField = getValueField();

    if (!isNullOrEmpty(currentRow[valueField])) {
      if (currentRow[valueField] != 0) {
        return responseResultError(res.rowNumberP1(1) + res.criticalMust0);
      }
      currentValue.value = currentRow[valueField];
    } else {
      return responseResultError(res.rowNumberP1(1) + res.criticalOnly1);
    }

    if (!isNullOrEmpty(currentRow.standardValue)) {
      if (currentRow.isQuantity === false && (currentRow.standardValue < 0 || 1 < currentRow.standardValue)) {
        return responseResultError(res.rowNumberP1(1) + res.rebateRateMust0_1);
      } else if (currentRow.isQuantity === true && !isInDirect && currentRow.standardValue < 0) {
        return responseResultError(res.rowNumberP1(1) + res.unitFeeMustGt0);
      }
      currentValue.standardValue = currentRow.standardValue;
    } else {
      return responseResultError(res.rowNumberP1(1) + res.resultOnly1);
    }

    values.push(currentValue);

    let lastValue = currentValue;
    for (let i = 1; i < rows.length; i++) {
      currentRow = rows[i];
      currentValue = {};

      if (isNullOrEmpty(currentRow.standardValue)) {
        break;
      }

      if (!isNullOrEmpty(currentRow.standardValue)) {
        if (currentRow.isQuantity === false && (currentRow.standardValue < 0 || 1 < currentRow.standardValue)) {
          return responseResultError(res.rowNumberP1(i + 1) + res.rebateRateMust0_1);
        } else if (currentRow.isQuantity === true && !isInDirect && currentRow.standardValue < 0) {
          return responseResultError(res.rowNumberP1(i + 1) + res.unitFeeMustGt0);
        }
        currentValue.standardValue = currentRow.standardValue;
      } else {
        return responseResultError(res.rowNumberP1(i + 1) + res.resultOnly1);
      }

      if (isNullOrEmpty(currentRow[valueField])) {
        return responseResultError(res.rowNumberP1(i + 1) + res.criticalOnly1);
      }
      currentValue.value = currentRow[valueField];

      if (lastValue.value >= currentValue.value) {
        return responseResultError(res.rowNumberP1(i + 1) + res.currentMustGtLast);
      }

      values.push(currentValue);
      lastValue = currentValue;
    }
  }
  return responseResultOk({data: values});
};

export {convertToResult, initSalesContractRateGrid, SCTRateGrid};
